import { BaseDto } from '@/shared/dtos/base-dto';

export class ApexCharsSeries extends BaseDto {
    public name : string='';
    public data : number[]=[];
} 
